import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'motion/react';

import confetti from '../../assets/video/confetti.webm';

export const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
  delayTransition,
  mode,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(() => currentState === 'S6', [currentState]);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const letters = 'ПОБЕДИТЕЛЬ!'.split('').reverse();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: { duration: 1, delay: delayTransition },
      }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles['wrapper']}
    >
      <div className={styles.firstLine} dir="rtl">
        {isWinner &&
          letters.map((l, idx, arr) => {
            let initialIdx = 3;
            let oneLetterWidth = 6;
            let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  x: initialX,
                }}
                animate={{
                  scale: 1,
                  x: 0,
                }}
                transition={{
                  duration: 0.7,
                  delay: idx * 0.15 + 2,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => {
              const msg = mode === 'allMessages' ? item.message : item;
              const key =
                mode === 'allMessages'
                  ? item.id
                  : item.senderNumber + item.author;
              const currentId =
                mode === 'allMessages' ? item.id : item.senderNumber;

              return (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    isWinner={isWinner}
                    winId={winId}
                    key={key}
                    message={msg}
                    authorFontSize={authorFontSize}
                    currentId={currentId}
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
      </div>

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}
    </motion.div>
  );
};
